import { Divider, Grid, Typography } from '@mui/material'

import MealsPerMealtype from './mealsPerMealtype/MealsPerMealtype';
import MealsPerMealtypeContainingRecipe from './mealsPerMealtypeContainingRecipe/MealsPerMealtypeContainingRecipe';
import styles from './plannedMealsForToday.module.css';
import { Tramsformed_Meal } from '../../../mealPlanPage/mealPlan.types';
import { isRecipeInMeals } from '../../../mealPlanPage/utils';

const PlannedMealsForToday = ({ recipe, meals }: { recipe: any, meals: Tramsformed_Meal[] | null }) => (
    <Grid className={styles.plannedMealsContainer}>
      <Divider
        className={styles.rightDivider}
        textAlign="left"
      >
        <Typography className={styles.headingText} variant="caption4Outfit">Planned for the day</Typography>
      </Divider>
      <Grid className={styles.mealsContainer}>
        {meals && meals.length && meals.map((item, index) => {
          if (item?.meals?.length === 0) return null;

          const isRecipeInMealtype = isRecipeInMeals(item?.meals, recipe?.id);
          if (isRecipeInMealtype)
            return <MealsPerMealtypeContainingRecipe key={`${index}-${item?.typeName}`} mealType={item?.typeName} meals={item?.meals} />
          return <MealsPerMealtype key={`${index}-${item?.typeName}`} mealType={item?.typeName} meals={item?.meals}  />
        })}
      </Grid>
    </Grid>
  )

export default PlannedMealsForToday